import React, { ReactElement } from 'react';
import { Col, Row, Typography } from 'antd';
import { Logo } from '@components/layout';
import LoginProviderSelection from '@views/main/LoginProviderSelection';

const { Title, Text } = Typography;

interface LoginSelectionProps {
  showLoading?: boolean;
  extra?: string | ReactElement;
  loading?: boolean;
  showMessage?: string;
  message?: string;
}

const LoginSelection = (props: LoginSelectionProps) => {
  return (
    <div
      className={'login-container'}
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#ffffff',
      }}
    >
      <div className="login-content-wrapper">
        <Row justify="center">
          <Col span={24}>
            <div className="text-center">
              <div className="mb-5">
                <Logo mobileLogo={false} />
              </div>
              <div className="mb-5">
                <div
                  style={{
                    fontFamily: "'Montserrat Alternates', sans-serif",
                    fontSize: '24px',
                    fontWeight: 700,
                    lineHeight: 1.4,
                  }}
                >
                  <span style={{ color: '#4403B5' }}>고객의 소리</span>
                  <span style={{ color: '#595959' }}>를</span>
                  <br />
                  <span style={{ color: '#4403B5' }}>
                    AI가 자동으로 전달해
                  </span>{' '}
                  <span style={{ color: '#595959' }}>드립니다</span>
                </div>
              </div>
              <LoginProviderSelection {...props} />
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default LoginSelection;
